import { baseApi } from '@/services'
import { IMessage } from '@/types/unlock'

export const messageApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getMessages: builder.query<IMessage[], string | string[]>({
      query: (externalId) =>
        `v2/messages/?parent_message__isnull=True&application__external_id=${externalId}`,
      providesTags: ['Message'],
    }),
    getReplies: builder.query<IMessage[], any>({
      query: ({ externalId, parentMessageId }) =>
        `v2/messages/?parent_message=${parentMessageId}&application__external_id=${externalId}`,
    }),
    createMessage: builder.mutation<IMessage, any>({
      query: (body: IMessage) => ({
        method: 'POST',
        url: 'v2/messages/',
        body,
      }),
      invalidatesTags: ['Message'],
    }),
    createRequestEsignature: builder.mutation<IMessage, any>({
      query: (body: IMessage) => ({
        method: 'POST',
        url: 'v2/messages/request-esignature/',
        body,
      }),
      invalidatesTags: ['Message'],
    }),
    deleteMessage: builder.mutation<IMessage, any>({
      query: (uuid) => ({
        method: 'DELETE',
        url: `v2/messages/${uuid}/`,
      }),
      invalidatesTags: ['Message'],
    }),
  }),
})

export const {
  useGetMessagesQuery,
  useLazyGetRepliesQuery,
  useCreateMessageMutation,
  useDeleteMessageMutation,
  useCreateRequestEsignatureMutation,
} = messageApi
